import { partners, operations } from 'api';
import {
  SET_OPERATION_PROPERTY,
  ADD_CONTACT_PROSPECT,
  DELETE_CONTACT_PROSPECT,
  COPY_DATA_CONTACT_TO_ATTORNEY,
  SET_CUSTOMER_TYPE_OPERATION,
  RESET_OPERATION_DATA,
  CREATE_NEW_OPERATION,
  CREATE_OPERATION_DATA_TO_SEND,
  NOT_INTERESTED_OPERATION,
  RESEND_EMAIL,
  CANCEL_OPERATION,
  GOTO_AMZ,
  GOTO_DIGITAL_CONTRACT,
  DELETE_DATA_TO_SEND,
  SET_TO_MANUAL_STUDY,
  OPERATION_SAVE_HOLDER_MOBILE,
  OPERATION_SEND_SMS,
  RESEND_SIGNATURE,
  CREATION_PROSPECT_RISK,
  RESET_PROSPECTB2B_DATA,
  PROSPECT_GET_RISKS,
  PROSPECT_CANCEL_OPERATION,
  CANCEL_NEW_OPERATION_ACTIVE_B2C
} from 'store/actions/operation';
import { UI_SET_LOADER_TEXT_MODAL } from 'store/actions/ui';
import { i18n } from '@/setup/i18n';
import { base64ToUtf8, serializeUrl } from 'helpers/string';
import { userProfile, userContactId, userHasPartnerRole } from 'helpers/user';
import { OPERATION_STATUS } from 'store/enums';

export default {
  [RESET_OPERATION_DATA]: ({ commit }) => commit(RESET_OPERATION_DATA),

  [RESET_PROSPECTB2B_DATA]: ({ commit }) => commit(RESET_PROSPECTB2B_DATA),

  [SET_OPERATION_PROPERTY]: ({ commit }, { field, value }) =>
    commit(SET_OPERATION_PROPERTY, {
      field,
      value
    }),

  [ADD_CONTACT_PROSPECT]: ({ commit }) => commit(ADD_CONTACT_PROSPECT),

  [DELETE_DATA_TO_SEND]: ({ commit }) => commit(DELETE_DATA_TO_SEND),

  [DELETE_CONTACT_PROSPECT]: ({ commit }, { index }) =>
    commit(DELETE_CONTACT_PROSPECT, {
      index
    }),

  [COPY_DATA_CONTACT_TO_ATTORNEY]: ({ commit }) => commit(COPY_DATA_CONTACT_TO_ATTORNEY),

  [SET_CUSTOMER_TYPE_OPERATION]: ({ commit }, { value }) =>
    commit(SET_CUSTOMER_TYPE_OPERATION, {
      value
    }),

  [CREATE_NEW_OPERATION]: ({ state, commit }, id) =>
    new Promise(async (resolve, reject) => {
      const { partnerid, idc, name } = await userProfile();
      const partnerId = partnerid || id;
      const idC = state.idC || idc;
      let contactId = '';
      if (userHasPartnerRole()) {
        contactId = await userContactId();
      }

      commit(CREATE_OPERATION_DATA_TO_SEND, {
        partnerId,
        name,
        idC,
        contactId
      });
      partners.createNewOperationByPartner(partnerId, state.dataToSend).then(
        resp => {
          const data = resp.data || false;
          commit(RESET_OPERATION_DATA);
          resolve(data);
        },
        err => {
          if (err.response.data.code === 409 && [13, 18].includes(err.response.data.errorCode)) {
            reject(err.response.data);
          } else {
            commit(RESET_OPERATION_DATA);
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          }
        }
      );
    }),

  [CANCEL_NEW_OPERATION_ACTIVE_B2C]: ({ state, commit }, { id, guid }) =>
    new Promise(async (resolve, reject) => {
      const { partnerid, idc, name } = await userProfile();
      const partnerId = partnerid || id;
      const idC = state.idC || idc;
      let contactId = '';
      if (userHasPartnerRole()) {
        contactId = await userContactId();
      }

      commit(CREATE_OPERATION_DATA_TO_SEND, {
        partnerId,
        name,
        idC,
        contactId
      });
      operations.cancelOperationActiveB2C(guid, state.dataToSend).then(
        resp => {
          const data = resp.data || false;
          commit(RESET_OPERATION_DATA);
          resolve(data);
        },
        err => {
          if (err.response.data.code === 409 && [13, 18].includes(err.response.data.errorCode)) {
            reject(err.response.data);
          } else {
            commit(RESET_OPERATION_DATA);
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          }
        }
      );
    }),

  [CREATION_PROSPECT_RISK]: (
    { commit, dispatch },
    { partnerId, campaignId, email, documentId, businessName }
  ) =>
    new Promise((resolve, reject) => {
      operations.processRisk({ partnerId, campaignId, email, documentId, businessName }).then(
        resp => {
          const { data } = resp;
          if (data.risks) {
            commit(`ui/${UI_SET_LOADER_TEXT_MODAL}`, i18n.t('message.generic.textRiskModal'), {
              root: true
            });
            // eslint-disable-next-line max-nested-callbacks
            const promises = data.risks.map(url =>
              dispatch(PROSPECT_GET_RISKS, serializeUrl(base64ToUtf8(url)))
            );
            Promise.all(promises)
              .then(
                // eslint-disable-next-line max-nested-callbacks
                () => {
                  resolve(data);
                }
              )
              .catch(() => {
                resolve({
                  guid: data.prospect.process.transactionId,
                  messageShow: i18n.t('message.error.riskKo'),
                  errorCode: 'risks'
                });
              });
          } else {
            reject();
          }
        },
        err => {
          const { status, data } = err.response;
          if (status === 409 || status === 403) {
            resolve(data);
          } else {
            reject();
          }
        }
      );
    }),

  [PROSPECT_CANCEL_OPERATION]: (
    { commit, dispatch },
    { guid, partnerId, campaignId, email, documentId, businessName }
  ) =>
    new Promise((resolve, reject) => {
      operations
        .cancelOperationActive({ guid, partnerId, campaignId, email, documentId, businessName })
        .then(
          resp => {
            const { data } = resp;
            dispatch(SET_OPERATION_PROPERTY, {
              field: 'guidToCancel',
              value: null
            });
            if (data.risks) {
              commit(`ui/${UI_SET_LOADER_TEXT_MODAL}`, i18n.t('message.generic.textRiskModal'), {
                root: true
              });
              // eslint-disable-next-line max-nested-callbacks
              const promises = data.risks.map(url =>
                dispatch(PROSPECT_GET_RISKS, serializeUrl(base64ToUtf8(url)))
              );
              Promise.all(promises)
                .then(
                  // eslint-disable-next-line max-nested-callbacks
                  () => {
                    resolve(data);
                  }
                )
                .catch(() => {
                  resolve({
                    guid: data.prospect.process.transactionId,
                    messageShow: i18n.t('message.error.riskKo'),
                    errorCode: 'risks'
                  });
                });
            } else {
              reject();
            }
          },
          err => {
            const { status, data } = err.response;
            if (status === 409 || status === 403) {
              resolve(data);
            } else {
              reject();
            }
          }
        );
    }),

  // eslint-disable-next-line no-unused-vars
  [PROSPECT_GET_RISKS]: ({ commit, dispatch }, url) =>
    new Promise((resolve, reject) => {
      operations
        .getRisks(url)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          const { data } = err.response;
          reject(data);
        });
    }),

  [NOT_INTERESTED_OPERATION]: (params, { id, cancelUser }) =>
    new Promise((resolve, reject) => {
      operations
        .notInterestedOperation({ id, cancelUser })
        .then(
          resp => {
            if (OPERATION_STATUS.OK === resp.data.code) resolve();
            else reject();
          },
          () => {
            reject();
          }
        )
        .catch(() => reject);
    }),

  [RESEND_EMAIL]: (params, { idSecuencial, envioMail, estadoAprobacion }) =>
    new Promise((resolve, reject) => {
      operations
        .resendEmail({
          idSecuencial,
          envioMail,
          estadoAprobacion
        })
        .then(() => resolve())
        .catch(() => reject());
    }),

  [RESEND_SIGNATURE]: (params, { operationGuid }) =>
    new Promise((resolve, reject) => {
      operations
        .resendSignature({
          operationGuid,
          retailSessionTrace: 6
        })
        .then(() => resolve())
        .catch(() => reject());
    }),

  [CANCEL_OPERATION]: (params, { id }) =>
    new Promise((resolve, reject) => {
      operations
        .cancelOperation({
          id
        })
        .then(() => resolve())
        .catch(error => reject(error.response.data));
    }),

  [GOTO_AMZ]: (params, orderId) => {
    const APP_SELLER_AMAZON_URL =
      process.env.APP_SELLER_AMAZON_URL.lastIndexOf('/') !==
      process.env.APP_SELLER_AMAZON_URL.length - 1
        ? `${process.env.APP_SELLER_AMAZON_URL}/`
        : process.env.APP_SELLER_AMAZON_URL;
    window.open(`${APP_SELLER_AMAZON_URL}${orderId}`);
  },

  [GOTO_DIGITAL_CONTRACT]: (params, data) => {
    const urlRedirect = data.urlDigitalContract || process.env.APP_TESLA_URL;
    const urlRedirectParsed =
      urlRedirect.lastIndexOf('/') !== urlRedirect.length - 1 ? `${urlRedirect}/` : urlRedirect;
    window.open(`${urlRedirectParsed}${data.operationGuid}`);
  },

  [SET_TO_MANUAL_STUDY]: (params, { operationId, operationGuid }) =>
    new Promise((resolve, reject) => {
      operations
        .setToManualStudy({ operationId, operationGuid })
        .then(resp => {
          resolve(resp.data);
        })
        .catch(error => {
          reject(error.response.data);
        });
    }),

  [OPERATION_SAVE_HOLDER_MOBILE]: (params, { operationGuid, newMobile }) =>
    new Promise((resolve, reject) => {
      operations
        .saveHolderMobile({ operationGuid, newMobile })
        .then(resp => {
          resolve(resp.data);
        })
        .catch(error => reject(error));
    }),

  [OPERATION_SEND_SMS]: (params, { operationId }) =>
    new Promise((resolve, reject) => {
      operations
        .sendSMS({ operationId })
        .then(resp => {
          resolve(resp.data);
        })
        .catch(error => reject(error));
    })
};
